/**
 * Universal Ribbon Banner - Countdown Timer
 * Works on any Shopify theme
 */

(function() {
  'use strict';
  
  //Initialize all countdowns on the page
  function initCountdowns() {
    const countdowns = document.querySelectorAll('.ribbon-countdown[data-end-date]');
    
    countdowns.forEach(function(countdown) {
      const endDateStr = countdown.getAttribute('data-end-date');
      const endTimeStr = countdown.getAttribute('data-end-time') || '23:59:59';
      
      if (!endDateStr) return;
      
      // Parse end date/time
      const endDateTime = new Date(endDateStr + ' ' + endTimeStr).getTime();
      
      if (isNaN(endDateTime)) {
        console.error('Invalid countdown date:', endDateStr);
        return;
      }
      
      // Get countdown elements
      const daysEl = countdown.querySelector('[data-unit="days"]');
      const hoursEl = countdown.querySelector('[data-unit="hours"]');
      const minutesEl = countdown.querySelector('[data-unit="minutes"]');
      const secondsEl = countdown.querySelector('[data-unit="seconds"]');
      const messageEl = countdown.parentElement.querySelector('.countdown-end-message');
      
      // Get end action
      const endAction = countdown.getAttribute('data-end-action') || 'hide';
      const endMessage = countdown.getAttribute('data-end-message') || '';
      
      // Update countdown
      function updateCountdown() {
        const now = new Date().getTime();
        const distance = endDateTime - now;
        
        if (distance < 0) {
          // Countdown finished
          if (endAction === 'hide') {
            countdown.style.display = 'none';
            if (messageEl) messageEl.style.display = 'none';
          } else if (endAction === 'show_zero') {
            if (daysEl) daysEl.textContent = '00';
            if (hoursEl) hoursEl.textContent = '00';
            if (minutesEl) minutesEl.textContent = '00';
            if (secondsEl) secondsEl.textContent = '00';
          } else if (endAction === 'show_message') {
            countdown.style.display = 'none';
            if (messageEl) {
              messageEl.innerHTML = endMessage;
              messageEl.style.display = 'block';
            }
          }
          return;
        }
        
        // Calculate time units
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        // Update display
        if (daysEl) daysEl.textContent = padZero(days);
        if (hoursEl) hoursEl.textContent = padZero(hours);
        if (minutesEl) minutesEl.textContent = padZero(minutes);
        if (secondsEl) secondsEl.textContent = padZero(seconds);
      }
      
      // Initial update
      updateCountdown();
      
      // Update every second
      const interval = setInterval(updateCountdown, 1000);
      
      // Store interval ID for cleanup
      countdown.dataset.intervalId = interval;
    });
  }
  
  // Pad single digit numbers with zero
  function padZero(num) {
    return num < 10 ? '0' + num : num.toString();
  }
  
  // Cleanup function
  function cleanupCountdowns() {
    const countdowns = document.querySelectorAll('.ribbon-countdown[data-interval-id]');
    countdowns.forEach(function(countdown) {
      const intervalId = countdown.dataset.intervalId;
      if (intervalId) {
        clearInterval(parseInt(intervalId));
        delete countdown.dataset.intervalId;
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }
  
  // Re-initialize on Shopify section events
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', function() {
      cleanupCountdowns();
      initCountdowns();
    });
    
    document.addEventListener('shopify:section:unload', cleanupCountdowns);
  }
  
})();
